import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/function-component-definition */
import React from 'react';
import { Typography, Button } from '@mui/material';
export default function ShowMoreText({ text, defaultShow, cutOff = 400 }) {
    const [showMore, setShowMore] = React.useState(defaultShow);
    return (_jsxs(Typography, { className: "description", variant: "body2", sx: { whiteSpace: 'pre-line' }, children: [showMore ? text : text.substring(0, cutOff), text.length > cutOff && (_jsx(Button, { disableRipple: true, variant: "text", size: "small", className: "showMoreLinkColor", onClick: () => setShowMore(!showMore), sx: {
                    ml: 0.5,
                    p: 0,
                    typography: 'body2',
                    fontWeight: (theme) => theme.typography.fontWeightBold,
                    color: (t) => t.portal?.courseDisplay?.showMoreLinkColor?.color,
                    textTransform: 'none',
                    '&:hover': {
                        background: 'none',
                        textDecoration: 'underline',
                    },
                }, children: showMore ? 'Show less' : 'Show more' }))] }));
}
ShowMoreText.defaultProps = {
    defaultShow: false,
    cutOff: 400,
};
//# sourceMappingURL=ShowMoreText.js.map